export default "/images/6081cd88497712c22412e9b29c4b1cb0.avif";